import React, { useEffect, useState } from "react";
import { useSelector,useDispatch } from "react-redux";
import IsLoadingHOC from "../common/IsLoadingHOC";
import { authAxios } from "../config/config";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { formatText } from "../helper/helper";
import { setrefetch } from "../Redux/Reducers/authSlice";

const PressPage = (props) => {
  const { setLoading } = props;
  const userName = useSelector((state) => state.auth.user.fname);
  const location = useLocation();
  const ids = location?.state?.id;
  const [formValues, setFormValues] = useState({
    Headline: "",
    Subheadline: "",
    City: "",
    Date: "",
    Introduction: "",
    Detailed_Information: "",
    Key_Quotes: "",
    Background_or_Context: "",
    Impact_and_Future_Plans: "",
    Call_to_Action: "",
  });

  const [storyDetail, setstoryDetail] = useState([]);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const endpoint = editable ? 'press/editPressRelease' : 'press/submit_form';
    
    const payload = {
      Headline: formValues.Headline || "",
      Subheadline: formValues.Subheadline || "",
      City: formValues.City || "",
      Date: formValues.Date || "",
      Introduction: formValues.Introduction || "",
      Detailed_Information: formValues.Detailed_Information || "",
      Key_Quotes: formValues.Key_Quotes || "",
      Background_or_Context: formValues.Background_or_Context || "",
      Impact_and_Future_Plans: formValues.Impact_and_Future_Plans || "",
      Call_to_Action: formValues.Call_to_Action || "",
      ...(editable && { _id: storyId })
    };
    try {
      const response = await authAxios().post(endpoint, payload);
      const resData = response?.data;
      setstoryDetail(resData.data);
      dispatch(setrefetch("press"))
      toast.success(resData?.message);
      
      sessionStorage.removeItem("editable")
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const editable = sessionStorage.getItem("editable");

  const storyId = sessionStorage.getItem("story_id");

  const fetchstory = async () => {
    setLoading(true);
    await authAxios()
      .post(`/press/getsPressRelase`, { _id: storyId })
      .then((response) => {
        setLoading(false);
        const data = response?.data?.data;

        setFormValues((prevValues) => ({
          ...prevValues,
          ...data,
        }));

        setstoryDetail(data);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };
  useEffect(() => {
    if (storyId) {
      fetchstory();
    }
  }, [storyId]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
      title: formValues.Entrepreneurs_Full_Name,
    });
  };

  const handleback =()=>{
    sessionStorage.removeItem("story_id");
    sessionStorage.removeItem("formType");
  navigate("/")

  }
  const dispatch = useDispatch()

  useEffect(() => {
    sessionStorage.removeItem("editable");
  }, []);
  return (
    <>
      <div className="h-full flex flex-col justify-between">
        <div>
          <style>
            {`
              .custom-scrollbar::-webkit-scrollbar {
                width: 10px;
              }
              .custom-scrollbar::-webkit-scrollbar-thumb {
                background: #E5EDFF;
                border-radius: 10px;
              }
            `}
          </style>

          <div
            className={`py-[20px] overflow-auto h-[calc(100vh-100px)] pb-[35px] custom-scrollbar`}
          >
            <div className="bg-[#E5EDFF] border-[2px] border-[#2553be] p-[15px] rounded-[10px] flex items-center gap-5 max-w-[885px] w-full mx-auto mb-5">
              <div>
                <img
                  src="./assets/images/press-c.png"
                  alt="image"
                  className="w-[65px] aspect-square"
                  onClick={handleback}
                />
              </div>
              <p className="text-[#2C2C2C] text-[20px] font-semibold">
                Write your Press Release
              </p>
            </div>

            <div className="max-w-[885px] w-full mx-auto">
              <div className="bg-[#E5EDFF] rounded-t-[10px] min-h-[88px] text-center p-[20px] flex items-center justify-center border-b-[2px] border-b-[#fff]">
                <h1 className="text-[#000] lg:text-[40px] font-[600] text-[25px]">
                  Welcome <span className="capitalize">{userName}!</span>
                </h1>
              </div>

              <form
                onSubmit={handleSubmit}
                className="bg-[#E5EDFF] lg:p-[40px] p-[15px] lg:pb-[10px] rounded-b-[10px]"
              >
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessName"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What is the main title of this press release?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      type="text"
                      name="Headline"
                      value={formValues.Headline}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What is the secondary title that provides more context?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Subheadline"
                      value={formValues.Subheadline}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      Which city is this news related to?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="City"
                      value={formValues.City}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      On what date did this event occur?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="Date"
                      value={formValues.Date}
                      onChange={handleInputChange}
                      className={`min-h-[50px] rounded-[8px] p-[15px]  ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What is the brief summary or introduction of this story?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Introduction"
                      value={formValues.Introduction}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="businessIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What are the in-depth details of the event or issue?
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Detailed_Information"
                      value={formValues.Detailed_Information}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What are the significant quotes or statements from key
                      individuals? <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Key_Quotes"
                      value={formValues.Key_Quotes}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      What background information or context should be provided?{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Background_or_Context"
                      value={formValues.Background_or_Context}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      How will this event affect the future, and what are the
                      upcoming plans? <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Impact_and_Future_Plans"
                      value={formValues.Impact_and_Future_Plans}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      // className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${storyDetail ? 'bg-white' : ''}`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>
                <div className="flex flex-col lg:flex-row gap-3 mb-3">
                  <div className="w-full flex flex-col gap-y-[10px]">
                    <label
                      htmlFor="entrepreneurIntroduction"
                      className="text-[#000000] text-[16px] font-[400]"
                    >
                      More information for the audience{" "}
                      <span className="text-red-500">*</span>
                    </label>
                    <textarea
                      name="Call_to_Action"
                      value={formValues.Call_to_Action}
                      onChange={handleInputChange}
                      className={`lg:min-h-[150px] min-h-[80px] rounded-[8px] p-[15px] ${
                        storyDetail ? "bg-white" : ""
                      }`}
                      required
                     disabled={storyDetail?.story && !editable}
                    />
                  </div>
                </div>

                {storyDetail?.story ? (
                  <>
                  <div className="flex flex-col lg:flex-row gap-3 mb-3 bg-white p-5 rounded-[10px]">
                    <div className="w-full flex flex-col gap-y-[10px]">
                      <div>
                        <img src="./assets/images/PR.png" alt="Your Company" />
                        <br />
                        {formatText(storyDetail?.story)}
                      </div>
                    </div>
                  </div>
                  <div className="flex justify-center py-3">
                    <button
                      type="submit"
                      className="bg-[#2553be] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                    >
                      Regenerate
                    </button>
                  </div>
                  </>
                ) : (
                  <div className="flex justify-center py-3">
                    <button
                      type="submit"
                      className="bg-[#2553be] text-[#FFFFFF] text-[16px] font-[600] rounded-[8px] py-[15px] px-[30px] min-w-[130px]"
                    >
                      Submit
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default IsLoadingHOC(PressPage);
